import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.Title',
    defaultMessage: 'Change Floor Plan',
  },
  descriptionLineOne: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.DescriptionLineOne',
    defaultMessage: 'Update the floor plan associated with this unit.',
  },
  floorPlanLabel: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.FloorPlanLabel',
    defaultMessage: 'Floor Plan',
  },
  unitStatusLabel: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.UnitStatusLabel',
    defaultMessage: 'Unit Status',
  },
  bannerImmediate: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.BannerImmediate',
    defaultMessage:
      "This unit will be updated to the new floorplan immediately. Select 'Save' to continue.",
  },
  bannerScheduled: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.BannerScheduled',
    defaultMessage:
      'This unit will be updated to the new floorplan on {date} after ' +
      "move-out is completed. Select 'Save' to continue.",
  },
  errorNoNtv: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.ErrorNoNtv',
    defaultMessage:
      'A Notice to Vacate must be entered on the Resident Profile before this floor plan change can be scheduled.',
  },
  errorNoMoveOutDate: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.ErrorNoMoveOutDate',
    defaultMessage:
      'A scheduled move-out date must be provided on the Resident Profile ' +
      'before this floor plan change can be scheduled.',
  },
  cancel: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.Save',
    defaultMessage: 'Save',
  },
  saveError: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.SaveError',
    defaultMessage: 'Unable to update the floor plan. Please try again.',
  },
  moveOutDateInfo: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.MoveOutDateInfo',
    defaultMessage: 'Move-out date: {date}',
  },
  saveSuccessImmediate: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.SaveSuccessImmediate',
    defaultMessage: 'Floor plan updated successfully.',
  },
  saveSuccessScheduled: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.SaveSuccessScheduled',
    defaultMessage: 'Floor plan change scheduled successfully.',
  },
  saveSuccessCanceled: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.SaveSuccessCanceled',
    defaultMessage: 'Scheduled floor plan change canceled.',
  },
  iaConfirmTitle: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.IaConfirmTitle',
    defaultMessage:
      'Are you sure you want to change the floor plan for this unit?',
  },
  iaConfirmDescription: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.IaConfirmDescription',
    defaultMessage:
      // eslint-disable-next-line max-len
      'This floor plan will change the Income Average to the following percentage and may be over the required limit for your property:',
  },
  iaWithChanges: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.IaWithChanges',
    defaultMessage: 'IA with Change',
  },
  requiredIa: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.RequiredIa',
    defaultMessage: 'Required IA',
  },
  naurEventLabel: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurEventLabel',
    defaultMessage: 'Select NAUR Event to Satisfy (Optional)',
  },
  naurEventPlaceholder: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurEventPlaceholder',
    defaultMessage: '-- Select a NAUR Event --',
  },
  naurEventNoneOption: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurEventNoneOption',
    defaultMessage: '-- None --',
  },
  naurEventDisabledTooltip: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurEventDisabledTooltip',
    defaultMessage: 'No qualifying open NAUR events for this bedroom size',
  },
  naurUpdateError: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurUpdateError',
    defaultMessage:
      'Floor plan updated but unable to associate NAUR event. Please try updating the NAUR association separately.',
  },
  naurAssociationUpdated: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.NaurAssociationUpdated',
    defaultMessage: 'NAUR event association updated successfully.',
  },
  hudSubsidyType: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.HudSubsidyType',
    defaultMessage: 'HUD Subsidy Type',
  },
  hudSubsidyTypeTooltip: {
    id: 'App.ViewUnit.ChangeFloorPlanModal.HudSubsidyTypeTooltip',
    defaultMessage:
      'Subsidy Type options include the Contract #. This is to ensure the correct Contract # is tied to this unit.',
  },
});

export default messages;
